<template>
  <div>
    <dt>{{ label }}</dt>
    <dd v-if="disciplina">{{ disciplina.DISCIPLINA }}</dd>
  </div>
</template>

<script>
import MatriculaService from "../../../../domain/corpore/MatriculaService";
import SwalMessage from "../../../../domain/message/SwalMessage";

export default {
  name: "view-c-protocolo-disciplina-ativa",
  $_veeValidate: {
    validator: "new"
  },
  inject: ["$validator"],
  props: {
    label: String,
    value: String,
    login: String
  },
  asyncComputed: {
    disciplina() {
      const matriculaService = new MatriculaService(this.$http);
      return matriculaService
        .getDisciplinasMatricula(this.login)
        .then(result =>
          result.find(disciplina => this.value == disciplina.CODDISC)
        )
        .catch(err => {
          SwalMessage.warningMessage(`<p>${err.message}</p>`, "Ops!");
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Protocolo/View/DisciplinaAtiva.vue